import { useTranslate } from '@/hooks/useTranslate';
import { ButtonType } from '@/types/components';
import { Button } from '@/components/Common/Button';
import { FontAwesomeIcon } from '@/components/Common/FontAwesomeIcon/FontAwesomeIcon';
import { cn } from '@/utils/cn';
import X from '@/assets/icons/common/X.svg';

interface OptOutResultProps {
  isSuccess: boolean;
  isPending?: boolean;
  onClose: () => void;
  onRetry?: () => void;
}

export const OptOutResult = ({ isSuccess, isPending = false, onClose, onRetry }: OptOutResultProps) => {
  const { t } = useTranslate();

  return (
    <div data-testid={isSuccess ? 'do-not-sell-success' : 'do-not-sell-error'} className="flex w-full flex-col gap-6">
      <div className="flex w-full justify-end">
        <img
          data-testid="do-not-sell-modal-close"
          src={X}
          alt="x"
          className="mt-0.5 size-4 shrink-0 cursor-pointer opacity-70"
          onClick={onClose}
        />
      </div>
      <div className="flex w-full flex-col items-center gap-6 text-center">
        <FontAwesomeIcon
          icon={isSuccess ? 'fa-regular fa-circle-check' : 'fa-regular fa-circle-xmark'}
          className={cn('text-5xl', isSuccess ? 'text-green-600' : 'text-red-600')}
        />
        <p id="do-not-sell-modal-title" className="text-sm leading-6 text-base-foreground">
          {t(isSuccess ? 'doNotSellSuccess' : 'doNotSellError')}
        </p>
      </div>
      {isSuccess ? (
        <Button type={ButtonType.DARK} className="h-11 text-base" onClick={onClose}>
          {t('close')}
        </Button>
      ) : (
        <Button type={ButtonType.DARK} className="h-11 text-base" isLoading={isPending} onClick={() => onRetry?.()}>
          {t('retry')}
        </Button>
      )}
    </div>
  );
};
